<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }"
            >首页</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/marketing_operations/c_data_operations_home' }">销售管理</el-breadcrumb-item>
        <el-breadcrumb-item>赛事产品</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>

    <el-card>
      SPBCN 个人赛销售管理
    </el-card>

    <!-- 顶部统计卡片 -->
    <el-row :gutter="20" class="stat-cards">
      <el-col :span="6" v-for="(item, index) in statCards" :key="index">
        <div class="stat-card" :class="{ active: activeIndex === index }" :style="{ borderBottomColor: item.color, '--arrow-color': item.color }" @click="activeIndex = index">
          <div class="stat-icon" :style="{ backgroundColor: item.color }">
            <i :class="item.icon"></i>
          </div>
          <div class="stat-content">
            <div class="stat-title">{{ item.title }}</div>
            <div class="stat-desc">{{ item.desc }}</div>
            <div class="stat-count" :style="{ color: item.color }">{{ item.count }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- C端用户列表（总线索池） -->
    <el-card v-if="activeIndex === 0" class="list-card">
      <div slot="header" class="card-header">
        <span>C端用户列表</span>
      </div>
      <el-form :model="queryForm" ref="queryFormRef" label-width="90px" class="filter-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="赛区" prop="districtId">
              <el-select v-model="queryForm.districtId" placeholder="请选择赛区" clearable style="width: 100%">
                <el-option v-for="item in districtList" :key="item.id" :label="item.districtName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="学校" prop="schoolId">
              <el-select v-model="queryForm.schoolId" placeholder="请选择学校" clearable filterable style="width: 100%">
                <el-option v-for="item in schoolList" :key="item.id" :label="item.schoolName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="年级" prop="grade">
              <el-select v-model="queryForm.grade" placeholder="请选择年级" clearable style="width: 100%">
                <el-option v-for="item in gradeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="组别" prop="groupType">
              <el-select v-model="queryForm.groupType" placeholder="请选择组别" clearable style="width: 100%">
                <el-option v-for="item in groupList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="queryForm.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" align="right">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleFollowTarget">跟进目标</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table :data="tableData" border stripe v-loading="loading">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="userName" label="姓名" min-width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
        <el-table-column prop="schoolName" label="学校" min-width="150"></el-table-column>
        <el-table-column prop="districtName" label="赛区" width="120"></el-table-column>
        <el-table-column prop="grade" label="年级" width="80"></el-table-column>
        <el-table-column prop="groupType" label="组别" width="80"></el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="160"></el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px; text-align: right"
      ></el-pagination>
    </el-card>

  </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: 0,
      loading: false,
      total: 0,
      tableData: [],
      schoolList: [],
      districtList: [],
      gradeList: [
        { label: '一年级', value: '1' },
        { label: '二年级', value: '2' },
        { label: '三年级', value: '3' },
        { label: '四年级', value: '4' },
        { label: '五年级', value: '5' },
        { label: '六年级', value: '6' },
        { label: '七年级', value: '7' },
        { label: '八年级', value: '8' },
        { label: '九年级', value: '9' }
      ],
      groupList: [
        { label: '小学组', value: 'PRIMARY' },
        { label: '初中组', value: 'JUNIOR' },
        { label: '高中组', value: 'SENIOR' }
      ],
      queryForm: {
        schoolId: '',
        districtId: '',
        grade: '',
        groupType: '',
        phone: '',
        userName: '',
        pageNum: 1,
        pageSize: 10
      },
      statCards: [
        {
          title: '总线索池',
          desc: '原始客户信息',
          count: 1000,
          color: '#409EFF',
          icon: 'el-icon-s-data'
        },
        {
          title: 'SQL-销售合格线索',
          desc: '有较高的跟进价值',
          count: 0,
          color: '#67C23A',
          icon: 'el-icon-s-check'
        },
        {
          title: '私海客户',
          desc: '已分配线索',
          count: 0,
          color: '#E6A23C',
          icon: 'el-icon-s-custom'
        },
        {
          title: '未分配线索',
          desc: '未分配',
          count: 0,
          color: '#F56C6C',
          icon: 'el-icon-s-release'
        }
      ]
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    handleSearch () {
      this.queryForm.pageNum = 1
      this.getDataList()
    },
    handleReset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleFollowTarget () {
      this.$message.success('跟进目标')
    },
    handleSizeChange (val) {
      this.queryForm.pageSize = val
      this.getDataList()
    },
    handleCurrentChange (val) {
      this.queryForm.pageNum = val
      this.getDataList()
    },
    handleDetail (row) {
      console.log('详情', row)
    },
    getDataList () {
      this.loading = true
      // TODO: 调用接口获取数据
      // this.$http.get('xxx/page', { params: this.queryForm }).then(res => {
      //   if (res.code === 200) {
      //     this.tableData = res.data.records
      //     this.total = res.data.total
      //   }
      // }).finally(() => {
      //   this.loading = false
      // })
      this.loading = false
    },
    getSchoolList () {
      // TODO: 获取学校列表
    },
    getDistrictList () {
      // TODO: 获取赛区列表
    }
  },
  created () {
    this.getDataList()
    this.getSchoolList()
    this.getDistrictList()
  }
}

</script>
<style lang="less" scoped>
.stat-cards {
  margin: 20px 0;
}
.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 10px 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-bottom: 4px solid;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
  }
  &.active::after {
    content: '';
    position: absolute;
    bottom: -16px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 12px solid var(--arrow-color);
  }
  .stat-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    i {
      font-size: 28px;
      color: #fff;
    }
  }
  .stat-content {
    flex: 1;
    .stat-title {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 4px;
    }
    .stat-desc {
      font-size: 12px;
      color: #909399;
      margin-bottom: 8px;
    }
    .stat-count {
      font-size: 28px;
      font-weight: bold;
    }
  }
}
</style>
